import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useContext } from "react";
import { DialogProvider, createDialogContext } from "../../../Common/Dialog";

export const DeleteContactDialogContext = createDialogContext();

const DeleteContactDialog = ({
  onClose,
  isLoading = false,
}: {
  onClose: () => void;
  isLoading?: boolean;
}) => {
  const { isOpen, title, actions } = useContext(DeleteContactDialogContext);

  const _onClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={_onClose}
      isCentered
      closeOnOverlayClick={!isLoading}
    >
      <ModalOverlay />
      <ModalContent mb={[0, "auto"]} borderRadius="lg" maxW="400px" p={2}>
        <ModalHeader textAlign="center" fontWeight="600" pb={2}>
          {title}
        </ModalHeader>
        <ModalCloseButton isDisabled={isLoading} />
        <ModalBody textAlign="center" pb={4}>
          <Text color="gray.600">
            This will permanently delete this contact and remove all associated
            information. This can't be undone.
          </Text>
        </ModalBody>
        <ModalFooter pt={0} pb={4}>
          <HStack width="100%" spacing={3}>
            {actions.map((action, index) => (
              <Button
                key={action.text}
                onClick={action.onClick}
                flex={1}
                isLoading={isLoading && index === actions.length - 1}
                isDisabled={isLoading}
                {...action.buttonProps}
              >
                {action.text}
              </Button>
            ))}
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const withDeleteContactDialog =
  <T extends object>(Component: React.ComponentType<T>) =>
  (props: T) => {
    return (
      <DialogProvider context={DeleteContactDialogContext}>
        <Component {...(props as T)} />
      </DialogProvider>
    );
  };

export default DeleteContactDialog;
